/**
 * The host adapter for the `creative-picker` client-side entity (ADR-037 D8).
 * The executor (in `@fias/client-entities`) runs with only
 * `{ userId, archeId, holderId }`; the plugin renderer that mounted an arche
 * registers here the function that draws ITS picker, and the executor reaches
 * it by arche id. An arche with no mounted renderer answers PICKER_UNAVAILABLE.
 */

import type {
  CreativePickerHost,
  CreativePickerKind,
  CreativePickerResult,
} from '@fias/client-entities';

type PickerHandler = (kind: CreativePickerKind | null) => Promise<CreativePickerResult>;

const handlers = new Map<string, PickerHandler>();

/** Called by the plugin renderer on mount; returns the unregister function. */
export function registerCreativePicker(archeId: string, handler: PickerHandler): () => void {
  handlers.set(archeId, handler);
  return () => {
    if (handlers.get(archeId) === handler) handlers.delete(archeId);
  };
}

export const creativePickerHost: CreativePickerHost = {
  async showPicker({ archeId, kind }) {
    const handler = handlers.get(archeId);
    if (!handler) {
      return {
        error: {
          code: 'PICKER_UNAVAILABLE',
          message: 'The Creative Library picker is not available here',
        },
      };
    }
    return handler(kind);
  },
};
